<script setup lang="ts">
// Vue & Plugins
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'

// Components
import LoadingPage from './LoadingPage.vue'

// Composables
import { usePrimeVue } from 'primevue/config'
import { useNavigatorLanguage } from '@vueuse/core'
import { useIsDark } from './common/composables/useIsDark'
import { useNavigation } from './navigation/composables/useNavigation'

// Stores
import { useAuthUserStore } from './user/authUserStore'
import { useRoute } from 'vue-router'

// Data
// TODO: Remove inherit attrs flag if we dont need it.
//  This was added to fix a vue warning where props were being passed to the root element.
defineOptions({
  inheritAttrs: false
})

// TODO: Fix how we handle setting the locale, this is a temp fix and proof of concept for configuring outside of en/en-US
const { language } = useNavigatorLanguage()
watch(language, (value) => {
  const primeVue = usePrimeVue()

  if (value === 'en-GB') {
    if (primeVue.config.locale) {
      primeVue.config.locale.dateFormat = 'dd/mm/yy'
    }
  }
}, { immediate: true })

const { loadingMessage } = useNavigation()
const authUserStore = useAuthUserStore()
const { isInitialising, isAuthenticated, isInitialisingSite } = storeToRefs(authUserStore)

const isDebug = import.meta.env.DEV
const { toggleDarkMode } = useIsDark()
const toggleColorScheme = () => {
    document.documentElement.classList.toggle('dark')

    toggleDarkMode()
}

const route = useRoute()
const requiresOrganisation = computed(() => route.meta.requiresOrganisation)
</script>

<template>
  <!-- Dark Mode Toggle -->
  <Button
    v-if="isDebug"
    icon="pi pi-palette"
    aria-label="palette"
    class="fixed top-0 left-0 z-50 h-8 w-8 opacity-5 hover:opacity-100"
    @click="toggleColorScheme"
  />

  <LoadingPage
    v-if="isInitialising || (isAuthenticated && requiresOrganisation && isInitialisingSite)"
    :message="loadingMessage"
  />

  <router-view
    v-else
  />

  <Toast />
</template>
